import { Group } from 'modules/expenses/hooks/useGroup'
import { PolicyTarget } from 'modules/permissions/store/collections/policyAuthorizations'

const GROUP_CLASS = 'Expenses::ExpensableGroup'

export const isDraftGroup = (group: Group) => group.status === 'draft'

export const isPendingGroup = (group: Group) => group.status === 'pending'

export const isChangesRequestedGroup = (group: Group) => group.status === 'changes_requested'

export const isRejectedGroup = (group: Group) => group.status === 'rejected'

export const createGroupPolicyTarget = (group: Group): PolicyTarget => ({
  id: group.id,
  policyTargetClass: `::${GROUP_CLASS}`,
})
